import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import { getEnvironment, isNotDev } from '@openclassrooms/utils/environment';
import browser from '@openclassrooms/utils/browser';

export default {
  async install({ user, release } = {}) {
    Sentry.init({
      dsn: 'https://69ec9a700f3243e3a77942f82719d0d6@sentry.io/1329208',
      whitelistUrls: isNotDev() ? [/openclassrooms\.com/i] : [],
      environment: getEnvironment(),
      release,
      defaultIntegrations: false,
      integrations: [
        new Integrations.Dedupe(),
        new Sentry.Integrations.InboundFilters(),
        new Sentry.Integrations.FunctionToString(),
        new Sentry.Integrations.TryCatch(),
        new Sentry.Integrations.Breadcrumbs({
          console: false,
        }),
        new Sentry.Integrations.GlobalHandlers({
          onerror: true,
          onunhandledrejection: true,
        }),
        new Sentry.Integrations.UserAgent(),
      ],
      ignoreErrors: ['fbq', 'TypeError: Failed to fetch'],
    });

    Sentry.configureScope((scope) => {
      scope.setUser(user);
      scope.setTag('supported_browser', browser.isSupported());
    });
  },

  captureError(error, options = {}) {
    const { context, type } = options;

    Sentry.withScope((scope) => {
      if (context) {
        scope.setExtras(context);
      }

      if (type) {
        scope.setTag('type', type);
      }

      Sentry.captureException(error);
    });
  },
};
